import { Component } from '@angular/core';
import {
  UserExtraInfoModel,
  UserModel,
  UsersService,
} from '../users/users.service';
import { BaseService } from '../../../base.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from '../../../toast.service';
import {
  LicenseManagementService,
  PlanModel,
  PlanFeatureDetail,
  FeatureComparison,
  LicenseFeatureEditRequest
} from './license-management.service';
@Component({
  selector: 'app-license',
  templateUrl: './license.component.html',
  styleUrl: './license.component.scss'
})
export class LicenseComponent {
  constructor(
    public UsersService: UsersService,
    public BaseService: BaseService,
    public router: Router,
    private route: ActivatedRoute,
    public ToastService: ToastService,
    private licenseManagementService: LicenseManagementService
  ) { }
  ModalVisible: boolean = false;
  ModalVisibleLicenseDetails: boolean = false;
  customStylesValidated: boolean = false;
  Loading: boolean = false;
  ButtonLoading: boolean = false;
  EditMode: boolean = false;
  details_visible = Object.create({});
  toggleDetails(item: any) {
    this.details_visible[item] = !this.details_visible[item];
  }




  userInfo: any;
  UserData: any;
  IsAdmin: boolean = false;
  ngOnInit(): void {
    this.userInfo = JSON.parse(localStorage.getItem('UserInfo') || '{}');
    this.UserData = this.userInfo;
    if (this.userInfo.userType_Id == 3) {
      this.IsAdmin = true;
    }

    this.getLicenses(this.userInfo.id);
    this.getUserExtraInfo();
  }

  IsAddExtraInfo: boolean = false;
  getUserExtraInfo() {
    this.UsersService.getUserExtraInfo().subscribe({
      next: (res: any) => {
        if (res.data.find((x: any) => x.users_Id == this.userInfo.id)) {
          this.UsersService.UserExtraInfoData = res.data.find(
            (x: any) => x.users_Id == this.userInfo.id
          );
        } else {
          this.UsersService.UserExtraInfoData = new UserExtraInfoModel();
          this.UsersService.UserExtraInfoData.users_Id = this.userInfo.id;
          this.IsAddExtraInfo = true;
        }

        console.log(
          '🚀 > ProfileComponent > this.UsersService.getUserExtraInfo >  this.UsersService.UserExtraInfoData:',
          this.UsersService.UserExtraInfoData
        );
        console.log('🚀 > UserpageComponent > getUserExtraInfo > res:', res);
      },
      error: (error) => {
        console.error(error);
      },
    });
  }



  LicensesData: any;

  LicensesColumns: any = [
    {
      key: 'productName',
      label: 'Product Name',
    },
    {
      key: 'date_Start',
      label: 'Date Created',
    },
    {
      key: 'date_Expire',
      label: 'Expiry Date',
    },
    {
      key: 'isActive',
      label: 'Status',
    },
    {
      key: 'Actions',
      label: '',
      _style: { width: '20%' },
      filter: false,
      sorter: false,
    },
  ];



  LicensesDataToShow: any;
  licenseData: any;
  // Plan features mapped from plan.planDetail
  licensePlanFeatures: PlanFeatureDetail[] = [];
  getLicenses(id: any) {
    this.Loading = true;
    var body = {
      id: id,
      type: 'U',
    };
    console.log('🚀 > getLicenses > body:', body);

    this.UsersService.getAllLicensesByPersonID(body).subscribe({
      next: (res: any) => {
        console.log(
          '🚀 > this.UsersService.getAllLicensesByPersonID > res:',
          res
        );

        this.LicensesData = res.data;
        // this.LicensesDataToShow = this.LicensesData?.map((item: any) => {
        //   return {
        //     ...item,
        //     productName: item.license_Products[0].productName,
        //     date_Expire: item.license_Products[0].date_Expire,
        //     date_Start: item.license_Products[0].date_Start,
        //     isActive: item.license_Products[0].isActive,
        //     // extraNoOfStores: item.license_Products[0].extraNoOfStores,
        //     // isRMHCentral: item.licenseDetails[0].isRMHCentral,
        //   };
        // });
        this.LicensesDataToShow = res.data?.flatMap((item: any) => item.license_Products || []) || [];

        console.log(this.LicensesDataToShow);
        this.Loading = false;
      },
      error: (error) => {
        console.error(error);
        this.Loading = false;
      },
    });
  }

  ShowLicenseDetails(item: any) {
    console.log(this.LicensesDataToShow);
    console.log('🚀 > ClientpageComponent > ShowLicenseDetails > item:', item);
    this.licenseData = item;
    // Map the plan details to feature details to show on UI
    try {
      const mapped = this.licenseManagementService.mapPlanResponse(item?.plan);
      this.licensePlanFeatures = mapped?.details || [];
    } catch (e) {
      // if mapping fails, keep it empty
      this.licensePlanFeatures = [];
      console.error('Failed to map plan features', e);
    }
    this.toggleModalLicenseDetails();
  }

  toggleModalLicenseDetails() {
    if (this.ModalVisibleLicenseDetails) {
      this.customStylesValidated = false;
      this.UsersService.UserData = new UserModel();
      this.EditMode = false;
    }
    this.ModalVisibleLicenseDetails = !this.ModalVisibleLicenseDetails;
  }


  upgradeModalVisible = false;
  downgradeModalVisible = false;
  selectedLicense: any = null;

  // New properties for plan management
  planSelectionModalVisible = false;
  confirmationModalVisible = false;
  availablePlans: PlanModel[] = [];
  selectedPlan: PlanModel | null = null;
  featureComparison: FeatureComparison | null = null;
  loadingPlans = false;
  processingPlanChange = false;

  /**
   * Open the plan selection modal (replaces upgrade/downgrade)
   */
  openManageModal(item: any) {
    this.selectedLicense = item;
    this.loadingPlans = true;
    this.planSelectionModalVisible = true;

    console.log('Selected License:', item);

    // Load available plans for this product
    this.licenseManagementService.getPlansByProductId(item.product_Id).subscribe({
      next: (res: any) => {
        console.log('Plans API Response:', res);
        if (res.data && Array.isArray(res.data)) {
          // Map plans using the service method
          this.availablePlans = res.data
            .map((plan: any) => this.licenseManagementService.mapPlanResponse(plan))
            .filter((plan: PlanModel | null): plan is PlanModel =>
              !!plan && plan.details && plan.details.length > 0 && !plan.isDemo
            )
            .sort((a: PlanModel, b: PlanModel) => {
              // Sort: Demo first, then by price
              if (a.isDemo && !b.isDemo) return -1;
              if (!a.isDemo && b.isDemo) return 1;
              const totalA = this.licenseManagementService.getPlanTotal(a, this.selectedLicense);
              const totalB = this.licenseManagementService.getPlanTotal(b, this.selectedLicense);
              return totalA - totalB;
            });

          console.log('Mapped Plans:', this.availablePlans);
        }
        this.loadingPlans = false;
      },
      error: (error) => {
        console.error('Error loading plans:', error);
        this.ToastService.showToast({
          title: 'Error',
          description: 'Failed to load plans',
          color: 'danger'
        });
        this.loadingPlans = false;
        this.planSelectionModalVisible = false;
      }
    });
  }

  /**
   * User selects a plan from the list
   */
  selectPlan(plan: PlanModel) {
    // Get current plan ID
    const currentPlanId = this.selectedLicense.planMaster_Id ||
      this.selectedLicense.plan_Id ||
      this.selectedLicense.plan?.id;

    if (currentPlanId === plan.id) {
      this.ToastService.showToast({
        title: 'Info',
        description: 'This is your current plan',
        color: 'info'
      });
      return;
    }

    this.selectedPlan = plan;
    this.loadingPlans = true;

    // Find current plan from available plans
    const currentPlan = this.availablePlans.find(p => p.id === currentPlanId);

    if (!currentPlan) {
      this.ToastService.showToast({
        title: 'Error',
        description: 'Could not find current plan information',
        color: 'danger'
      });
      this.loadingPlans = false;
      return;
    }

    // Compare features using the service
    this.featureComparison = this.licenseManagementService.compareFeatures(
      currentPlan,
      plan
    );

    console.log('Feature Comparison:', this.featureComparison);

    this.loadingPlans = false;
    this.planSelectionModalVisible = false;
    this.confirmationModalVisible = true;
  }

  /**
   * User confirms the plan change
   */
  confirmPlanChange() {
    if (!this.featureComparison || !this.selectedPlan || !this.selectedLicense) {
      return;
    }

    this.processingPlanChange = true;

    // Check if it's a downgrade
    if (this.featureComparison.isDowngrade) {
      // Use downgrade API for downgrades
      this.licenseManagementService.downGradeLicensePlan(
        this.selectedLicense.id || this.selectedLicense.licenseProduct_Id,
        this.selectedPlan.id
      ).subscribe({
        next: (res) => {
          console.log('Downgrade API Response:', res);
          this.processingPlanChange = false;
          this.confirmationModalVisible = false;

          if (res.isSuccess) {
            this.ToastService.showToast({
              title: 'Success',
              description: 'Plan downgraded successfully!',
              color: 'success'
            });

            // Show downgrade notification modal
            this.showDowngradeNotification(this.selectedLicense.date_Expire);

            // Refresh licenses
            this.getLicenses(this.userInfo.id);
          } else {
            this.ToastService.showToast({
              title: 'Error',
              description: res.message || 'Failed to downgrade plan',
              color: 'danger'
            });
          }

          // Reset state
          this.selectedPlan = null;
          this.featureComparison = null;
          this.selectedLicense = null;
        },
        error: (error) => {
          console.error('Error downgrading plan:', error);
          this.processingPlanChange = false;
          this.ToastService.showToast({
            title: 'Error',
            description: 'Failed to downgrade plan. Please try again.',
            color: 'danger'
          });
        }
      });
    } else {
      // Use upgrade/edit features API for upgrades
      const request: LicenseFeatureEditRequest = this.licenseManagementService.buildEditFeaturesRequest(
        this.featureComparison,
        this.selectedLicense.id || this.selectedLicense.licenseProduct_Id,
        this.selectedPlan.id
      );

      console.log('Sending upgrade request:', request);

      this.licenseManagementService.editLicenseFeatures(request).subscribe({
        next: (res) => {
          console.log('Upgrade API Response:', res);
          this.processingPlanChange = false;
          this.confirmationModalVisible = false;

          if (res.apiStatus.isSuccess) {
            this.ToastService.showToast({
              title: 'Success',
              description: 'Plan upgraded successfully! Please pay the invoice in the Invoices section to activate the new features.',
              color: 'success'
            });

            // Show invoice notification modal
            this.showInvoiceNotification();

            // Refresh licenses
            this.getLicenses(this.userInfo.id);
          } else {
            this.ToastService.showToast({
              title: 'Error',
              description: res.apiStatus.message || 'Failed to change plan',
              color: 'danger'
            });
          }

          // Reset state
          this.selectedPlan = null;
          this.featureComparison = null;
          this.selectedLicense = null;
        },
        error: (error) => {
          console.error('Error upgrading plan:', error);
          this.processingPlanChange = false;
          this.ToastService.showToast({
            title: 'Error',
            description: 'Failed to upgrade plan. Please try again.',
            color: 'danger'
          });
        }
      });
    }
  }

  /**
   * Cancel plan change
   */
  cancelPlanChange() {
    this.confirmationModalVisible = false;
    this.planSelectionModalVisible = false;
    this.selectedPlan = null;
    this.featureComparison = null;
    this.selectedLicense = null;
  }

  /**
   * Show invoice notification modal
   */
  invoiceNotificationVisible = false;

  showInvoiceNotification() {
    this.invoiceNotificationVisible = true;
  }

  closeInvoiceNotification() {
    this.invoiceNotificationVisible = false;
  }

  goToInvoices() {
    this.invoiceNotificationVisible = false;
    this.router.navigate(['/invoices']);
  }

  /**
   * Show downgrade notification modal
   */
  downgradeNotificationVisible = false;
  downgradeInvoiceDate: string = '';

  showDowngradeNotification(invoiceDate?: string) {
    this.downgradeInvoiceDate = invoiceDate || '';
    this.downgradeNotificationVisible = true;
  }

  closeDowngradeNotification() {
    this.downgradeNotificationVisible = false;
  }

  /**
   * Get badge color for plan comparison
   */
  getPlanBadgeColor(plan: PlanModel): string {
    if (!this.selectedLicense) return 'secondary';

    const currentPlanId = this.selectedLicense.planMaster_Id ||
      this.selectedLicense.plan_Id ||
      this.selectedLicense.plan?.id;
    if (plan.id === currentPlanId) return 'primary';

    const currentPlan = this.availablePlans.find(p => p.id === currentPlanId);
    if (!currentPlan) return 'secondary';

    const planTotal = this.licenseManagementService.getPlanTotal(plan, this.selectedLicense);
    const currentTotal = this.licenseManagementService.getPlanTotal(currentPlan, this.selectedLicense);

    if (planTotal > currentTotal) return 'success';
    if (planTotal < currentTotal) return 'warning';
    return 'info';
  }

  /**
   * Get plan badge text
   */
  getPlanBadgeText(plan: PlanModel): string {
    if (!this.selectedLicense) return '';

    const currentPlanId = this.selectedLicense.planMaster_Id ||
      this.selectedLicense.plan_Id ||
      this.selectedLicense.plan?.id;
    if (plan.id === currentPlanId) return 'Current Plan';

    const currentPlan = this.availablePlans.find(p => p.id === currentPlanId);
    if (!currentPlan) return '';

    const planTotal = this.licenseManagementService.getPlanTotal(plan, this.selectedLicense);
    const currentTotal = this.licenseManagementService.getPlanTotal(currentPlan, this.selectedLicense);

    if (planTotal > currentTotal) return 'Upgrade';
    if (planTotal < currentTotal) return 'Downgrade';
    return 'Switch';
  }

  /**
   * Get total price for a plan
   */
  getPlanTotal(plan: PlanModel): number {
    return this.licenseManagementService.getPlanTotal(plan, this.selectedLicense);
  }

  /**
   * Get billing frequency label
   */
  getBillingFrequency(): string {
    return this.licenseManagementService.getBillingFrequency(this.selectedLicense);
  }

  /**
   * Get adjusted feature price based on billing duration
   */
  getFeaturePrice(price: number): number {
    if (!this.selectedLicense || !this.selectedLicense.plD_Duration) {
      return price;
    }

    if (this.selectedLicense.plD_Duration === 1) {
      return price;
    }

    // For yearly licenses, multiply by plD_ChargeDuration
    return price * (this.selectedLicense.plD_ChargeDuration || 1);
  }

  openUpgradeModal(item: any) {
    this.selectedLicense = item;
    this.upgradeModalVisible = true;
  }

  openDowngradeModal(item: any) {
    this.selectedLicense = item;
    this.downgradeModalVisible = true;
  }




  selectedUpgrade: any;

  confirmUpgrade(option: string) {
    if (option === 'stores') {
      // Increase No of Stores logic
    } else if (option === 'features') {
      // Add More Features logic
    }
    this.upgradeModalVisible = false;
  }


  selectedDowngrade: any;

  confirmDowngrade(option: string) {
    if (option === 'stores') {
      // Logic to reduce stores
    } else if (option === 'features') {
      // Logic to remove features
    }
    this.downgradeModalVisible = false;
  }

}
